"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addDirectDebitWidgets = void 0;
var DirectDebitAccountNumberCollapseLabelWidget_1 = require("./DirectDebitAccountNumberCollapseLabelWidget");
var SortCodeInputWithInfoQuestionWidget_1 = require("./SortCodeInputWithInfoQuestionWidget");
var ConfirmDirectDebitModalWidget_1 = require("./ConfirmDirectDebitModalWidget");
var DirectDebitAccountNamelWidget_1 = require("./DirectDebitAccountNamelWidget");
var DirectDebitPaymentPlanOutput_1 = require("../annual/motor/directDebit/DirectDebitPaymentPlanOutput");
var DirectDebitGuarantee_1 = require("../annual/motor/directDebit/DirectDebitGuarantee");
var DirectDebitExplanationWidget_1 = require("./DirectDebitExplanationWidget");
var addDirectDebitWidgets = function (extensions) {
    extensions.journeyComponents.addQuestionComponent({
        id: "directDebitAccountNumberCollapseLabelWidget",
        component: DirectDebitAccountNumberCollapseLabelWidget_1.DirectDebitAccountNumberCollapseLabelWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "sortCodeInputWithInfoQuestionWidget",
        component: SortCodeInputWithInfoQuestionWidget_1.SortCodeInputWithInfoQuestionWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "directDebitPaymentPlanOutput",
        component: DirectDebitPaymentPlanOutput_1.DirectDebitPaymentPlanOutput
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "directDebitGuarantee",
        component: DirectDebitGuarantee_1.DirectDebitGuarantee
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "confirmDirectDebitModalWidget",
        component: ConfirmDirectDebitModalWidget_1.ConfirmDirectDebitModalWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "directDebitAccountNameWidget",
        component: DirectDebitAccountNamelWidget_1.DirectDebitAccountNameWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "directDebitExplanationWidget",
        component: DirectDebitExplanationWidget_1.DirectDebitExplanationWidget
    });
};
exports.addDirectDebitWidgets = addDirectDebitWidgets;
//# sourceMappingURL=index.js.map